'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_split_Splittable$ListSplittable$() {
}
export { $c_Lcom_raquo_airstream_split_Splittable$ListSplittable$ as $c_Lcom_raquo_airstream_split_Splittable$ListSplittable$ };
$p = $c_Lcom_raquo_airstream_split_Splittable$ListSplittable$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_split_Splittable$ListSplittable$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_Splittable$ListSplittable$() {
}
export { $h_Lcom_raquo_airstream_split_Splittable$ListSplittable$ as $h_Lcom_raquo_airstream_split_Splittable$ListSplittable$ };
$h_Lcom_raquo_airstream_split_Splittable$ListSplittable$.prototype = $p;
var $d_Lcom_raquo_airstream_split_Splittable$ListSplittable$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_split_Splittable$ListSplittable$, "com.raquo.airstream.split.Splittable$ListSplittable$", ({
  hd: 1,
  hc: 1
}));
export { $d_Lcom_raquo_airstream_split_Splittable$ListSplittable$ as $d_Lcom_raquo_airstream_split_Splittable$ListSplittable$ };
var $n_Lcom_raquo_airstream_split_Splittable$ListSplittable$;
function $m_Lcom_raquo_airstream_split_Splittable$ListSplittable$() {
  if ((!$n_Lcom_raquo_airstream_split_Splittable$ListSplittable$)) {
    $n_Lcom_raquo_airstream_split_Splittable$ListSplittable$ = new $c_Lcom_raquo_airstream_split_Splittable$ListSplittable$();
  }
  return $n_Lcom_raquo_airstream_split_Splittable$ListSplittable$;
}
export { $m_Lcom_raquo_airstream_split_Splittable$ListSplittable$ as $m_Lcom_raquo_airstream_split_Splittable$ListSplittable$ };
